/**
 * Le visuel de l'accueil, à droite des titres qui défilent.
 *
 * L'image vient de la bannière publicitaire, mais allégée de tout ce qui y
 * était incrusté : le logo « DB AUTO » (l'ancienne marque), le bloc « −50 % »
 * et la bande d'arguments du bas. Deux raisons.
 *
 * La première est commerciale : une remise de 50 % est un engagement ferme.
 * Tant qu'elle n'existe pas pour de vrai, avec un code et des conditions, elle
 * n'a rien à faire sur le site.
 *
 * La seconde est technique : un texte dessiné dans une image n'est lu par
 * personne. Ni par Google, ni par un lecteur d'écran, et à peine par un œil
 * humain sur un téléphone.
 *
 * C'est aussi pourquoi le prix ci-dessous est du VRAI texte posé par-dessus la
 * photo, et non peint dedans. Un prix bouge ; une image, il faut la refaire.
 *
 * POIDS : 61 Ko en WebP, 31 Ko dans la version téléphone, contre 1,9 Mo pour
 * la bannière d'origine.
 */

/**
 * Le prix d'appel affiché sur la photo.
 *
 * Écrit en dur pour l'instant : c'est une ligne à changer ici le jour où le
 * tarif bouge. Le jour où la flotte sera plus fournie, mieux vaudra le calculer
 * — le prix du véhicule publié le moins cher — pour qu'il ne puisse jamais
 * mentir.
 */
const PRIX_A_PARTIR_DE = '25 000 F CFA';

export function HeroVisuel() {
  return (
    <div className="relative">
      {/* Une lueur aux couleurs de la marque, derrière la voiture. Purement
          décorative : masquée aux lecteurs d'écran. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-[6%] inset-y-[14%] rounded-full bg-brand-500/20 blur-3xl"
      />

      <div className="relative overflow-hidden rounded-2xl">
        <picture>
          {/* Sur téléphone, une image deux fois plus petite : inutile de faire
              télécharger 975 pixels de large pour un écran qui en affiche 390. */}
          <source media="(max-width: 640px)" srcSet="/voiture-accueil-640.webp" type="image/webp" />
          <source srcSet="/voiture-accueil.webp" type="image/webp" />
          <img
            src="/voiture-accueil.jpg"
            /* `width` et `height` réservent la place avant même que l'image
               arrive : sans eux, tout l'accueil sursaute au chargement. */
            width={975}
            height={520}
            alt="Un SUV récent, prêt à la location"
            /* Pas de chargement différé : c'est la première chose qu'on voit. */
            loading="eager"
            decoding="async"
            className="block w-full"
          />
        </picture>

        {/* ---------------------------------------------------------------- */}
        {/* Le prix d'appel                                                   */}
        {/* ---------------------------------------------------------------- */}
        {/*
          Fond BLANC OPAQUE, et non translucide.

          La version précédente utilisait `bg-white/92`. Cette classe n'existe
          pas : l'échelle d'opacité de Tailwind va de cinq en cinq, et 92 n'en
          fait pas partie. Tailwind l'ignore sans rien dire, le fond disparaît,
          et il ne reste qu'un rectangle flou illisible sur la carrosserie.

          Un prix doit se lire d'un coup d'œil, par-dessus une photo dont on ne
          maîtrise ni les couleurs ni la luminosité. Donc : fond plein, ombre
          marquée, et un trait magenta à gauche qui accroche l'œil.
        */}
        <p className="absolute bottom-3 left-3 flex items-center gap-2.5 rounded-xl bg-white py-2 pl-2.5 pr-3.5 shadow-lg ring-1 ring-black/5 sm:bottom-5 sm:left-5 sm:gap-3 sm:py-2.5 sm:pl-3 sm:pr-4">
          <span aria-hidden="true" className="h-8 w-1 shrink-0 rounded-full bg-brand-500 sm:h-10" />
          <span>
            <span className="block text-[10px] font-bold uppercase tracking-wider text-ink-600 sm:text-[11px]">
              À partir de
            </span>
            <span className="block text-[15px] font-extrabold leading-tight text-ink-950 sm:text-xl">
              {/* `tabular-nums` aligne les chiffres ; `whitespace-nowrap` évite
                  que « 25 000 F CFA » se coupe en deux sur un petit écran. */}
              <span className="whitespace-nowrap tabular-nums text-brand-600">
                {PRIX_A_PARTIR_DE}
              </span>
              <span className="whitespace-nowrap text-ink-700"> / jour</span>
            </span>
          </span>
        </p>
      </div>
    </div>
  );
}
